import { GetQueueRequests } from 'domain/usecases';
import { BaseHttpService } from 'main/factories/http';

export class RemoteGetQueueRequests extends BaseHttpService<GetQueueRequests.Model> implements GetQueueRequests {
  async get(params: GetQueueRequests.Params): Promise<GetQueueRequests.Model> {
    return await this.request<GetQueueRequests.Params>('get', {}, params);
  }
}
